import { omit } from "lodash";
import { create } from "zustand";
import { type Nav, type Org, nav, orgs } from "../config/const-orgs";

interface Store {
	currentOrg: Org;
	orgs: Org[];
	setCurrentOrg: (value: Org) => void;
	nav: Omit<typeof nav, "orgs">;
	currentNav: Nav[];
	setNav: (value: string) => void;
}

export const useOrgStore = create<Store>()((set) => ({
	currentOrg: orgs[0],
	currentNav: nav[orgs[0].key],
	orgs,
	nav,

	setCurrentOrg: (value) => {
		set((state) => ({
			currentOrg: value,
		}));
	},

	setNav: (value) => {
		set((state) => ({
			currentNav: state.nav[value],
		}));
	},
}));
